module.exports = __webpack_public_path__ + "static/assets/ed78c2ad9d965f457e779f0a4fc993a7.png";